import { ReactElement } from 'react';
import { AuthProvider } from '../contexts/AuthContext';
import Cadastro from './ClubeBeneficios/Cadastro';

export function ClubeBeneficiosPage(): ReactElement {
  return (
    <>
      <div className="max-[1524px]:px-4 h-full">
        <AuthProvider>
          <Cadastro />
        </AuthProvider>
      </div>
    </>
  );
}
